var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 16.08C17.74 16.08 17.06 16.38 16.54 16.85L9.41 12.7C9.46 12.47 9.5 12.24 9.5 12C9.5 11.76 9.46 11.53 9.41 11.3L16.46 7.19C17 7.69 17.71 8 18.5 8C20.16 8 21.5 6.66 21.5 5C21.5 3.34 20.16 2 18.5 2C16.84 2 15.5 3.34 15.5 5C15.5 5.24 15.54 5.47 15.59 5.7L8.54 9.81C8 9.31 7.29 9 6.5 9C4.84 9 3.5 10.34 3.5 12C3.5 13.66 4.84 15 6.5 15C7.29 15 8 14.69 8.54 14.19L15.66 18.35C15.61 18.56 15.58 18.78 15.58 19C15.58 20.61 16.89 21.92 18.5 21.92C20.11 21.92 21.42 20.61 21.42 19C21.42 17.39 20.11 16.08 18.5 16.08ZM18.5 4C19.05 4 19.5 4.45 19.5 5C19.5 5.55 19.05 6 18.5 6C17.95 6 17.5 5.55 17.5 5C17.5 4.45 17.95 4 18.5 4ZM6.5 13C5.95 13 5.5 12.55 5.5 12C5.5 11.45 5.95 11 6.5 11C7.05 11 7.5 11.45 7.5 12C7.5 12.55 7.05 13 6.5 13ZM18.5 20.02C17.95 20.02 17.5 19.57 17.5 19.02C17.5 18.47 17.95 18.02 18.5 18.02C19.05 18.02 19.5 18.47 19.5 19.02C19.5 19.57 19.05 20.02 18.5 20.02Z",
  fill: "#079D56"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_share.c96ae00f75a8b7ea5f9e07197dff60e7.svg";